export function AppPreviewProfileIcon({
  className,
  pathClassName,
}: {
  className?: string;
  pathClassName?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      className={className}
    >
      <path
        d="M2.59998 16.6667C4.54647 14.6021 7.18916 13.3333 10.1 13.3333C13.0108 13.3333 15.6535 14.6021 17.6 16.6667M13.85 6.25C13.85 8.32107 12.171 10 10.1 10C8.02891 10 6.34998 8.32107 6.34998 6.25C6.34998 4.17893 8.02891 2.5 10.1 2.5C12.171 2.5 13.85 4.17893 13.85 6.25Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={pathClassName}
      />
    </svg>
  );
}
